/**
 * Yup unfortunately uses context binding on the test function rather than arguments to expose it's useful metadata and
 * functions. In an object oriented environment like React this poses challenges with collisions for `this`. This
 * utility function takes the test function you'd like Yup to execute and mitigates the binding challenges so that your
 * test function is called with arguments of `value, { createError, options, parent, path, schema}`.
 *
 * @see {@link https://github.com/jquense/yup#mixedtestname-string-message-string--function-test-function-schema}
 * @example
 * class MyFormComponent {
 *   schema = yup.object().shape({
 *     someField: string.test('myTest', 'My error message.', yupTestContextHelper(this.myTest))
 *   })
 *
 *   myTest(value, yup) {
 *     // `value` is what user entered into the field
 *     // `yup.createError` is used to create and return a validation error
 *     // `yup.options` is the entire (values) object being validated
 *     // `yup.parent` is, in the case of a nested schema, the value of the parent object
 *     // `yup.path` is the string path of the current validation
 *     // `yup.schema` is the resolved schema object this test is running against
 *   }
 * }
 * @function yupTestContextHelper
 * @param {Function} fn - Test function to add to the Yup validation chain.
 * @return {Function} Simple wrapper function to get Yup's context.
 */
export default (fn: any) => {
  return function yupTestWrapper(this: any, value: any) {
    return fn(value, {
      createError: this.createError,
      options: this.options,
      parent: this.parent,
      path: this.path,
      schema: this.schema
    })
  }
}
